import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { advCampaign: { getAdvCampaign } } = apiUrls;

export const GET_ADV_CAMPAIGNS_SUCCESS = 'GET_ADV_CAMPAIGNS_SUCCESS';
export const GET_ADV_CAMPAIGNS_LOADING = 'GET_ADV_CAMPAIGNS_LOADING';


export const getAdvCampaignData = ({ fromDate, toDate }) => async (dispatch) => {
    try {
        const { url } = getAdvCampaign
        const requestData = {
            ...getAdvCampaign,
            url: url.replace('{{fromDate}}', fromDate).replace('{{toDate}}', toDate)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: GET_ADV_CAMPAIGNS_SUCCESS,
            data,
        })
    } catch (e) {

        dispatch({
            type: GET_ADV_CAMPAIGNS_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: GET_ADV_CAMPAIGNS_LOADING,
        isLoading
    })
}
